module.exports = __webpack_public_path__ + "static/media/progress.f28a86c2.png";